import Plyr from 'plyr';

export default {
  init() {
    // SCROLLED
    $(window).on('scroll', function() {
      if ($(window).scrollTop() > 1) {
        $('body').addClass('scrolled');
      }
      else {
        $('body').removeClass('scrolled');
      }
    });

    // SCROLL DOWN
    function scrollDown() {
      var vheight = $(window).height();
      $('html, body').animate({
        scrollTop: (Math.floor($(window).scrollTop() / vheight)+1) * vheight,
      }, 500);
    }

    // Click to Scroll DOWN Functions
    $('.scroll-down').click(function(event){
      scrollDown();
      event.preventDefault();
    });

    // HAMBURGER
    $('.hamburger').click(function() {
      $('body').toggleClass('hamburger-active');
    });

    $('.hamburger-bg').click(function() {
      $('.hamburger').toggleClass('active');
      $('body').toggleClass('hamburger-active');
    });

    // HAMBURGER SUBMENU
    $('.mobile-nav .menu-mobile-container ul li.menu-item-has-children').click(function() {
      if ($(this).hasClass('active')) {
        $(this).removeClass('active');
      } else {
        $('.mobile-nav .menu-mobile-container ul li.menu-item-has-children').removeClass('active');
        $(this).addClass('active');
      }
    });
  },
  finalize() {
    // This is the bare minimum JavaScript. You can opt to pass no arguments to setup.
    const player = new Plyr('#player', {
      ratio: '16:9',
      controls: ['mute', 'progress'],
      autopause: false,
      muted: true,
    });

    // Expose
    window.player = player;

    // Bind event listener
    function on(selector, type, callback) {
      document.querySelector(selector).addEventListener(type, callback, false);
    }

    // Play
    on('.js-play', 'click', () => {
      player.play();
      $('body').addClass('js-video-active');
    });

    // Pause
    on('.js-pause', 'click', () => {
      player.pause();
      $('body').removeClass('js-video-active');
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js